<template>
  <el-dialog
    :title="warehouseInfo.id ? '编辑仓库' : '新建仓库'"
    :visible.sync="visible"
    width="40%"
  >
    <el-form label-position="left" label-width="180px" :model="warehouseInfo">
      <el-form-item label="名称">
        <el-input
          v-model="warehouseInfo.wareName"
          placeholder="名称"
        ></el-input>
      </el-form-item>
      <el-form-item label="仓库负责人">
        <el-input
          v-model="warehouseInfo.wareContact"
          placeholder="负责人"
        ></el-input>
      </el-form-item>
      <el-form-item label="负责人电话">
        <el-input
          v-model="warehouseInfo.contactPhone"
          placeholder="电话"
        ></el-input>
      </el-form-item>
      <el-form-item label="仓库地址">
        <div style="text-align:left">
          <el-input maxlength='450' v-model="warehouseInfo.province" placeholder="省" style="width:100px;margin-right: 20px;" ></el-input>
          <el-input maxlength='450' v-model="warehouseInfo.city" placeholder="市"  style="width:100px;margin-right: 20px;"></el-input>
          <el-input maxlength='450' v-model="warehouseInfo.district" placeholder="区"  style="width:100px"></el-input>
        </div>
      </el-form-item>
      <el-form-item label="详细地址">
        <el-input maxlength='450' v-model="warehouseInfo.address" placeholder="地址"></el-input>
      </el-form-item>
      <el-form-item label="邮编">
        <el-input maxlength='450' v-model="warehouseInfo.postalCode" placeholder="邮编"></el-input>
      </el-form-item>
      <el-form-item label="仓库面积">
        <el-input maxlength='450' v-model="warehouseInfo.area" placeholder="面积">
          <template slot="append">平方米</template>
        </el-input>
      </el-form-item>
      <el-form-item label="最大处理大件箱数">
        <el-input
          v-model="warehouseInfo.throughputTob"
          placeholder="最大处理大件箱数"
        >
          <template slot="append">件</template>
        </el-input>
      </el-form-item>
      <el-form-item label="最大处理小件件数">
        <el-input
          v-model="warehouseInfo.throughputToc"
          placeholder="最大处理小件件数"
        >
          <template slot="append">件</template>
        </el-input>
      </el-form-item>
      <el-form-item label="备注">
        <el-input maxlength='450' v-model="warehouseInfo.remark" placeholder="备注" type="textarea"></el-input>
      </el-form-item>
      <!--      <el-form-item label="材料类型">-->
      <!--        <el-select v-model="boxInfo.type" placeholder="请选择">-->
      <!--          <el-option-->
      <!--              v-for="item in types"-->
      <!--              :key="item.value"-->
      <!--              :label="item.label"-->
      <!--              :value="item.value">-->
      <!--          </el-option>-->
      <!--        </el-select>-->
      <!--      </el-form-item>-->
      <el-form-item>
        <div style="text-align: left">
          <el-button type="primary" @click="onSubmit">确定</el-button>
          <el-button @click="visible = false">取消</el-button>
        </div>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
import { Validator } from "@/utils/verification";
export default {
  name: "SetWarehouse",
  data() {
    return {
      visible: false,
      warehouseInfo: {
        wareName: "",
        wareContact: "",
        contactPhone: "",
        address: "",
        area: "",
        throughputTob: "",
        throughputToc: "",
      },
    };
  },
  watch: {
    visible: function (newval) {
      if (!newval) {
        this.warehouseInfo = {
          wareName: "",
          wareContact: "",
          contactPhone: "",
          address: "",
          area: "",
          throughputTob: "",
          throughputToc: "",
        };
      }
    },
  },
  methods: {
    open: function (warehouseInfo) {
      this.visible = true;
      if (warehouseInfo) {
        this.warehouseInfo = warehouseInfo;
      }
    },
    onSubmit: function () {
      let validator = new Validator();
      validator.add(
        this.warehouseInfo.wareName,
        "isNoneEmpty",
        "请输入仓库名称"
      );
      validator.add(
        this.warehouseInfo.wareContact,
        "isNoneEmpty",
        "请输入仓库负责任人名称"
      );
      validator.add_batch(this.warehouseInfo.contactPhone, [
        { strategy: "isNoneEmpty", errorMsg: "请输入仓库负责任人电话" },
        { strategy: "isMobile", errorMsg: "电话号码格式错误" },
      ]);
      validator.loopAdd(
        [this.warehouseInfo.province,this.warehouseInfo.city,this.warehouseInfo.district],
        "isNoneEmpty",
        "请输入仓库省市区"
      );
      validator.add(
        this.warehouseInfo.address,
        "isNoneEmpty",
        "请输入仓库地址"
      );
      validator.add(this.warehouseInfo.postalCode, "isNoneEmpty", "请输入邮编");
      validator.add(this.warehouseInfo.area, "isNoneEmpty", "请输入仓库面积");
      validator.add(
        this.warehouseInfo.throughputTob,
        "isNoneEmpty",
        "请输入最大处理大件数"
      );
      validator.add(
        this.warehouseInfo.throughputToc,
        "isNoneEmpty",
        "请输入最大处理小件数"
      );
      let error = validator.start();
      if (error) {
        this.$message.error(error);
        return;
      }
      if (this.warehouseInfo.id) {
        this.$emit("updateWarehouse", this.warehouseInfo);
        return;
      }
      this.$emit("addWarehouse", this.warehouseInfo);
    },
  },
};
</script>

<style scoped></style>
